import React from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Row } from 'react-bootstrap'
import useQueryDevelopments from '@hooks/useQueryDevelopments'
import { RootState } from '@redux/store'
import { useSelector } from 'react-redux'

const GridDevelopments_5 = (props: RealEstateDataPageComponentData) => {
  const { global_data } = props
  const { align, columns, backgroundColor, backgroundHexa } = props

  const devCard = global_data.content?.cardsDevelopments?.type_id ?? '1'

  const { data: developments, isLoading } = useQueryDevelopments()

  const developmentFilters = useSelector((state: RootState) => state.developments)

  const filteredDevelopments = React.useMemo(() => {
    if (!developments) return []

    return developments.filter((development) => {
      const statusMatch =
        developmentFilters.constructionStatus === 'VER TODOS' ||
        !developmentFilters.constructionStatus ||
        development.construction_status.toString().toLowerCase() ===
          developmentFilters.constructionStatus.toLowerCase()

      const locationMatch = !developmentFilters.location
        ? true
        : development?.location?.name
            ?.toLowerCase()
            .includes(developmentFilters.location.toLowerCase())

      return statusMatch && locationMatch
    })
  }, [developments, developmentFilters])

  const Card = require(`@components/cardsDevelopments/${devCard}`)?.default

  return (
    <section
      className={
        `dev-grid-5 ${backgroundColor} pt-5` +
        (align === 'center' ? ' text-center ' : '') +
        (!isLoading && (developments?.length === 0 || developments === undefined) ? 'd-none' : '')
      }
      style={{
        backgroundColor: backgroundColor === 'background-picker' ? backgroundHexa : '',
      }}
    >
      <Row className="no-gutters mt-5 mt-lg-1 mb-lg-4">
        {!isLoading ? (
          filteredDevelopments!?.length > 0 ? (
            filteredDevelopments!?.map((development, index) => (
              <Col
                xs={12}
                lg={Number(columns) ?? 3}
                key={index}
                className="mb-5 mb-lg-4 pb-lg-2 px-lg-3"
              >
                <Card
                  key={index}
                  development={development}
                  global_data={global_data}
                />
              </Col>
            ))
          ) : (
            <h4 className="text-center">No hay emprendimientos</h4>
          )
        ) : (
          [1, 2, 3].map((index) => (
            <Col
              xs={12}
              lg={4}
              key={index}
            >
              <Card
                skeleton={true}
                global_data={global_data}
              />
            </Col>
          ))
        )}
      </Row>
    </section>
  )
}
export default GridDevelopments_5
